/* eslint-disable no-nested-ternary */
import React from 'react';
import './table.scss';
import PropTypes from 'prop-types';
import LoadingPlaceholder from 'components/loadingPlaceholder';
import Caret from 'components/caret';
import { TYPES } from 'envs';
import useFormatParties from '../../dataProvider/hooks/useFormatParties';
import { getSite } from '../../constants';

const TableCompare = ({
  data,
  oldData,
  year,
  electionNumber,
  electionType,
  placeId,
  hideSeats,
  isSenate,
  isCouncilor,
  showPerson,
  details,
  legend,
  type
}) => {
  const partyFormats = useFormatParties(
    data,
    oldData,
    year,
    electionNumber,
    electionType,
    placeId,
    [],
    getSite()
  );
  let leyenda = '';
  if (type === TYPES.MUNICIPAL) {
    if (placeId === '04013') {
      leyenda = '* CON ANDALUCÍA se compara con PODEMOS';
    }

    // Barcelona Cs compara con Barcelona  Percami ciutadans
    if (placeId === '08019') {
      leyenda =
        '* CS se compara con Barcelona pel Canvi-Ciutadans y TRIASXBCN se compara con JUNTS';
    }

    // en ceuta se compara Ceuta Ya con caballas
    if (placeId === '51001') {
      leyenda = '* CEUTA YA! se compara con CABALLAS';
    }

    // Cordoba CONAND compara con podemos
    if (placeId === '14021') {
      leyenda = '* CON ANDALUCÍA se compara con PODEMOS';
    }

    // Gijon  Convocatoria por gijon de iu
    if (placeId === '33024') {
      leyenda = '* CONVOCATORIA POR GIJÓN se compara con IU';
    }

    // Hospitalet de llobregat
    if (placeId === '08101') {
      leyenda = '* EN COMÚ PODEM se compara con LHECP-ECG';
    }
    // logroño
    if (placeId === '26089') {
      leyenda = '* UNIDAS se compara con PODEMOS ';
    }
  }

  if (partyFormats) {
    console.log('partyFormats', partyFormats);
  }
  if (!partyFormats) {
    return <LoadingPlaceholder />;
  }
  const label = type === TYPES.MUNICIPAL ? 'Concejales' : 'Escaños';

  return (
    <div className="table-datosContainer">
      <div className="table-datosScroll">
        <div className="table-wrapper">
          {data.length !== 0 && (
            <table
              summary={
                isSenate ? 'Senadores por partido' : 'Escaños por partido.'
              }
            >
              <thead>
                <tr>
                  <th className="partido">
                    {!showPerson ? 'Partido' : 'Representante'}
                  </th>
                  {!hideSeats && (
                    <th className="escanos">
                      {isSenate ? 'Senadores' : label}
                    </th>
                  )}
                  {details && <th className="porcentaje">%</th>}
                  {details && <th className="votos">Votos</th>}
                </tr>
              </thead>
              <tbody>
                {partyFormats &&
                  partyFormats.map(item =>
                    (item.votes !== undefined && item.votes > 0) ||
                    item.seats ? (
                      <tr key={item.name || item.partyAcronym || item.id}>
                        <td className="dato-nombre-partido">
                          <span
                            className="partido-color"
                            style={{
                              backgroundColor: item.partyColor
                            }}
                          />
                          <span className="partido">
                            {!showPerson
                              ? item.partyAcronym
                              : `${item.name} (${item.partyAcronym})`}
                          </span>
                        </td>
                        {!hideSeats && (
                          <td className="dato-escanos">
                            <span className="dato-seats">
                              {item.seats || '-'}
                            </span>
                            <Caret
                              difference={item.difference}
                              nodata={item.nodata}
                            />
                          </td>
                        )}
                        {details && (
                          <td className="dato-escanos dato-escanos--percent">
                            {item.votesPercent
                              ? Number(item.votesPercent).toLocaleString('es')
                              : '-'}
                          </td>
                        )}
                        {details && (
                          <td className="dato-escanos_votes">
                            {item.votesPercent
                              ? Number(item.votes).toLocaleString('de')
                              : '-'}
                          </td>
                        )}
                      </tr>
                    ) : (
                      <></>
                    )
                  )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className="legendContainer">
        {legend &&
          legend.map(legendItem => (
            <p key={legendItem} className="table-datosLegend">
              {legendItem}
            </p>
          ))}
        <p className="table-datosLegend">{leyenda}</p>
      </div>
    </div>
  );
};

TableCompare.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})]).isRequired,
  hideSeats: PropTypes.bool,
  isSenate: PropTypes.bool,
  isCouncilor: PropTypes.bool,
  legend: PropTypes.arrayOf(PropTypes.string),
  showPerson: PropTypes.bool,
  details: PropTypes.bool,
  oldData: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})])
    .isRequired,
  year: PropTypes.string.isRequired,
  electionNumber: PropTypes.string.isRequired,
  electionType: PropTypes.string.isRequired,
  placeId: PropTypes.string.isRequired
};

TableCompare.defaultProps = {
  hideSeats: false,
  isSenate: false,
  showPerson: false,
  details: false,
  isCouncilor: false,
  legend: null
};

export default TableCompare;
